<template>
  <v-container fluid class="home pt-4 pb-1" v-resize="onResize">
    <v-row justify="space-between" align="center">
      <v-col sm="10" class="py-0">
        <v-breadcrumbs divider="/" :items="items" class="pb-4"> </v-breadcrumbs>
      </v-col>
      <v-col sm="1" class="py-0 pr-8">
        <!-- eslint-disable-next-line -->
        <v-autocomplete
          hide-details
          single-line
          class="pt-0"
          :filter="filterCurrency"
          :items="currenciesGrouped"
          return-object
          item-text="currencyCode"
          item-value="currencyCode"
          @input="setCurrencySelected"
          :value="currencySelected"
          placeholder="Currency"
        >
          <template slot="item" slot-scope="data">
            <v-list-item-content v-if="data.item.header" v-text="data.item"></v-list-item-content>
            <v-divider v-else-if="data.item.divider" inset></v-divider>
            <template v-else>
              <v-list-item-avatar tile color="primary">
                <span class="white--text">{{ data.item.currencyCode }}</span>
              </v-list-item-avatar>
              <v-list-item-content class="pb-2">
                <v-list-item-title>{{ data.item.countryName }}</v-list-item-title>
                <v-list-item-subtitle v-html="data.item.region"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row class="px-4">
      <v-tabs
        class="mx-4 elevation-2"
        background-color="blue lighten-5"
        color="blue--text text--darken-3"
        v-model="filterTab"
        grow
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab ripple>
          By Sectors and Locations
        </v-tab>
        <v-tab ripple>
          By Companies
        </v-tab>
        <v-tab ripple>
          By Job Group
        </v-tab>
      </v-tabs>
    </v-row>
    <v-row>
      <v-tabs-items v-model="filterTab" class="px-4" style="width:100%;">
        <v-tab-item class="mt-3 px-7">
          <v-row>
            <v-card elevations="2" class="px-6 pt-4 pb-2" style="width:100%;">
              <v-row justify="space-between" align="center">
                <v-col sm="5" cols="12" class="pt-2 pb-0">
                  <!-- eslint-disable-next-line -->
                  <v-autocomplete
                    chips
                    dense
                    :items="allSectors"
                    hide-details
                    item-text="name"
                    deletable-chips
                    small-chips
                    clearable
                    item-value="name"
                    label="Sectors"
                    multiple
                    v-model="sectorsSelected"
                  ></v-autocomplete>
                </v-col>

                <v-col sm="5" cols="12" class="pt-2 pb-0">
                  <!-- eslint-disable-next-line -->
                  <v-autocomplete
                    chips
                    dense
                    :items="countriesWithHeader"
                    hide-details
                    deletable-chips
                    small-chips
                    clearable
                    @change="countriesForSectorChanged"
                    label="Locations"
                    item-text="countryName"
                    item-value="countryCode"
                    v-model="countriesSelected"
                    multiple
                  >
                    <template slot="item" slot-scope="data">
                      <v-list-item-content
                        v-if="data.item.header"
                        v-text="data.item"
                      ></v-list-item-content>
                      <v-divider v-else-if="data.item.divider" :inset="true"></v-divider>
                      <v-list-item-content v-else class="pb-2">
                        <v-list-item-title v-html="data.item.countryName"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.region"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row justify="space-between" align="center">
                <v-col sm="5" cols="12" class="pt-5 pb-3">
                  <!-- eslint-disable-next-line -->
                  <v-autocomplete
                    dense
                    label="Job Groups"
                    chips
                    hide-details
                    deletable-chips
                    small-chips
                    clearable
                    no-data-text="Select Sectors and Locations"
                    item-text="jobGroup"
                    item-value="jobGroup"
                    :items="onetJobGroups"
                    v-model="onetJobGroupsSelected"
                    multiple
                  ></v-autocomplete>
                </v-col>
                <v-col sm="5" cols="12" class="pt-5 pb-3">
                  <!-- eslint-disable-next-line -->
                  <v-autocomplete
                    dense
                    v-model="jobClassesSelected"
                    chips
                    :items="jobClassesWithAll"
                    clearable
                    hide-details
                    small-chips
                    label="MRC Job Classes"
                    deletable-chips
                    multiple
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </v-row>
          <v-row class="pb-4">
            <DetailsPlist
              :companiesSelected.sync="companiesSelectedForSector"
              :companyBenefits="companyBenefitsBySector"
              :loading="loading"
              :companyListHeight="companyListHeight"
              :headerHeight.sync="headerHeight"
              :companyOnHover.sync="companyOnHover"
              @showIncumbents="showIncumbents"
            >
            </DetailsPlist>
            <DetailsTabs
              :height="companyListHeight + headerHeight"
              :loading="loading"
              :currencySelected="currencySelected"
              :companiesSelected="companiesSelectedForSector"
              :companyBenefits="companyBenefitsBySector"
              :sectors="sectorsSelected"
              :onetJobGroups="onetJobGroupsSelected"
              :countries="countriesSelected.map((c) => getCountryName(c))"
              :jobClasses="jobClassesSelected"
              :companyOnHover="companyOnHover"
            >
            </DetailsTabs>
          </v-row>
        </v-tab-item>

        <v-tab-item class="mt-3 px-7">
          <v-row>
            <v-card elevation="2" class="px-6 pt-4 pb-2" style="width:100%;">
              <v-row justify="space-between" align="center">
                <v-col sm="3" cols="12" class="pt-2 pb-0">
                  <!-- eslint-disable-next-line -->
                  <v-autocomplete
                    clearable
                    dense
                    :items="allSectors"
                    hide-details
                    item-text="name"
                    item-value="name"
                    label="Sector"
                    v-model="sectorForCompanies"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col sm="3" cols="12" class="pt-2 pb-0">
                  <!-- eslint-disable-next-line -->
                  <v-autocomplete
                    clearable
                    dense
                    :items="countriesWithHeader"
                    hide-details
                    label="Location"
                    @change="countriesForCompanyChanged"
                    item-text="countryName"
                    item-value="countryCode"
                    v-model="countryForCompanies"
                  >
                    <template slot="item" slot-scope="data">
                      <v-list-item-content
                        v-if="data.item.header"
                        v-text="data.item"
                      ></v-list-item-content>
                      <v-divider v-else-if="data.item.divider" :inset="true"></v-divider>
                      <v-list-item-content v-else class="pb-2">
                        <v-list-item-title v-html="data.item.countryName"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.region"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col sm="6" cols="12" class="pt-2 pb-0">
                  <v-select
                    label="HKG Companies Filter"
                    dense
                    hide-details
                    clearable
                    :disabled="countryForCompanies !== 'HKG'"
                    :items="hkFilters"
                    v-show="countryForCompanies === 'HKG'"
                    v-model="hkFilter"
                  ></v-select>
                  <v-select
                    label="SGP Companies Filter"
                    dense
                    hide-details
                    clearable
                    :disabled="countryForCompanies !== 'SGP'"
                    :items="sgFilters"
                    v-show="countryForCompanies === 'SGP'"
                    v-model="sgFilter"
                  ></v-select>
                  <v-select
                    label="Companies Filter"
                    dense
                    hide-details
                    clearable
                    disabled
                    v-show="countryForCompanies !== 'SGP' && countryForCompanies !== 'HKG'"
                  ></v-select>
                </v-col>

                <v-col sm="6" cols="12" class="pa-0 pr-sm-4">
                  <v-row class="px-3 pt-2" justify="space-between" align="center">
                    <v-col cols="6" class="pt-6 pb-4">
                      <v-select
                        label="Revenue Filter"
                        dense
                        hide-details
                        clearable
                        :items="revenues"
                        v-model="revenueRangeSelected"
                      ></v-select>
                    </v-col>
                    <v-col cols="6" class="pt-6 pb-4">
                      <v-icon @click="revenueCustom = !revenueCustom">
                        more
                      </v-icon>
                    </v-col>
                  </v-row>
                  <v-row class="px-3 pt-2" justify="space-between" align="center"
                  v-show="revenueCustom">
                    <v-col cols="6" class="pt-2 pb-0">
                      <v-text-field
                        type="number"
                        label="Revenue from"
                        clearable
                        :rules="rules"
                        :error-messages="invalidRevenueRange"
                        suffix="M"
                        @click:clear="setRevenueFrom(null)"
                        @change="setRevenueFrom"
                        :prefix="currencySelected.currencyCode"
                        v-model="revenueFromDisplay"
                      >
                      </v-text-field>

                    </v-col>
                    <v-col cols="6" class="pt-2 pb-0">
                      <v-text-field
                        type="number"
                        label="Revenue to"
                        clearable
                        :rules="rules"
                        :error-messages="invalidRevenueRange"
                        suffix="M"
                        @click:clear="setRevenueTo(null)"
                        @change="setRevenueTo"
                        :prefix="currencySelected.currencyCode"
                        v-model="revenueToDisplay"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col sm="6" cols="12" class="pa-0 pl-sm-4">
                  <v-row class="px-3 pt-2" justify="space-between" align="center">
                    <v-col cols="6" class="pt-6 pb-4">
                      <v-select
                        label="Market Cap Filter"
                        dense
                        hide-details
                        clearable
                        :items="marketCaps"
                        v-model="marketCapRangeSelected"
                      ></v-select>
                    </v-col>
                    <v-col cols="6" class="pt-6 pb-4">
                      <v-icon @click="marketCapCustom = !marketCapCustom">
                        more
                      </v-icon>
                    </v-col>
                  </v-row>
                  <v-row class="px-3 pt-2" justify="space-between" align="center"
                  v-show="marketCapCustom">
                    <v-col xs="6" class="pt-2 pb-0">
                      <v-text-field
                        type="number"
                        label="Market Cap. from"
                        clearable
                        :rules="rules"
                        :error-messages="invalidMktCapRange"
                        suffix="M"
                        @click:clear="setMarketCapFrom(null)"
                        @change="setMarketCapFrom"
                        :prefix="currencySelected.currencyCode"
                        v-model="marketCapFromDisplay"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col xs="6" class="pt-2 pb-0">
                      <v-text-field
                        type="number"
                        label="Market Cap. to"
                        clearable
                        :rules="rules"
                        :error-messages="invalidMktCapRange"
                        suffix="M"
                        @click:clear="setMarketCapTo(null)"
                        @change="setMarketCapTo"
                        :prefix="currencySelected.currencyCode"
                        v-model="marketCapToDisplay"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col sm="10" lg="11" class="py-0 px-3">
                  <v-menu offset-y :close-on-content-click="false" max-height="351"
                    @input="companySearchInput=''">
                    <template v-slot:activator="{ on }">
                      <label class="text-caption v-label theme--light">
                        Companies
                      </label>
                      <div style="border-bottom: 1px solid #999;position:relative;" v-on="on"
                        class="pb-1 d-flex flex-row flex-wrap justify-start align-center">

                        <div style="position:absolute; height:100%; width:100%;"
                          class="d-flex flex-column justify-end"
                          v-if="publicCompaniesLoading || searchingCompanyByName">
                          <v-progress-linear height="2" rounded bottom
                            indeterminate
                            color="primary"
                          ></v-progress-linear>
                        </div>

                        <template v-for="item,i in companiesSelectedToAdd">
                          <v-chip v-if="i<4" :key="i" class="flex-grow-0 mx-1" small>
                            {{item.company}}
                          </v-chip>
                          <span v-if="i === 4" :key="i" class="grey--text caption flex-grow-0 mr-1">
                            (+{{ companiesSelectedToAdd.length - 4 }} others)
                          </span>
                        </template>
                        <input type="text" style="outline: none;"
                          class="flex-grow-1"
                          v-model="companySearchInput" @keyup.enter="searchCompanyName">
                        <v-icon @click.stop.prevent="companiesSelectedToAdd = []"
                          v-if="companiesSelectedToAdd.length > 0">
                          clear
                        </v-icon>
                      </div>
                    </template>
                    <v-list-item style="background-color:white;"
                      v-if="companiesForSearch.length === 0" @click="toggle">
                      <v-list-item-title>
                        {{ textForCompanySearch }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item style="background-color:white;"
                      v-if="companiesForSearch.length > 0" @click="toggle">
                      <v-list-item-icon>
                        <v-icon
                          color="primary"
                        >
                          {{ icon }}
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>
                        Select All
                        <span class="grey--text body-1">
                          ({{ companiesSelectedToAddInFiltered
                            .length }}/{{ companiesForSearchFiltered.length }})
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="companiesForSearch.length > 0"></v-divider>
                    <v-virtual-scroll item-height="56" :height="virtualScrollHeight"
                      :bench="5" :items="companiesForSearchFiltered"
                      v-if="companiesForSearch.length > 0">
                      <template v-slot:default="{ item }">
                        <v-list-item style="background-color:white;"
                          @click="addCompanySelected(item)"
                        >
                          <v-list-item-icon>
                            <v-icon
                              color="primary"
                            >
                              {{ companiesSelectedToAdd
                                .includes(item)?'check_box':'check_box_outline_blank' }}
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>{{ item.company }}</v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-virtual-scroll>
                  </v-menu>
                  <!-- <v-autocomplete
                    label="Companies"
                    v-model="companiesSelectedToAdd"
                    :items="companiesForSearch"
                    multiple
                    item-text="company"
                    hide-details
                    return-object
                    class=""
                    :allow-overflow="false"
                    small-chips
                    clearable
                    :no-data-text="textForCompanySearch"
                    :loading="publicCompaniesLoading || searchingCompanyByName"
                    @keyup.enter="searchCompanyName"
                    :search-input.sync="companySearchInput"
                    :menu-props="{ auto: false }"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple v-if="companiesForSearch.length > 0" @click="toggle">
                        <v-list-item-action>
                          <v-icon
                            :color="companiesSelectedToAdd.length > 0 ? 'primary darken-2' : ''"
                            >{{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title>
                          Select All
                          <span class="grey--text body-1">
                            ({{ companiesSelectedToAdd.length }}/{{ companiesForSearch.length }})
                          </span>
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider v-if="companiesForSearch.length > 0" class="my-1"> </v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 4">
                        <span>{{ item.company }}</span>
                      </v-chip>
                      <span v-if="index === 4" class="grey--text caption"
                        >(+{{ companiesSelectedToAdd.length - 4 }} others)</span
                      >
                    </template>
                  </v-autocomplete> -->
                </v-col>
                <v-col sm="2" lg="1" class="py-0 pl-2 pr-3">
                  <v-btn outlined color="primary" class="mt-4" block @click="addCompaniesByCompany"
                    >Add
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="py-2">
                <v-divider></v-divider>
              </v-row>
              <v-row class="px-3">
                <v-col sm="5" cols="12" class="px-0 pt-1 pb-3">
                  <!-- eslint-disable-next-line -->
                  <v-autocomplete
                    dense
                    label="Job Groups"
                    chips
                    hide-details
                    deletable-chips
                    item-text="jobGroup"
                    item-value="jobGroup"
                    :items="onetJobGroupsForCompanies"
                    v-model="onetJobGroupsSelectedForCompanies"
                    multiple
                    clearable
                  >
                  </v-autocomplete>
                </v-col>
                <v-spacer></v-spacer>
                <v-col sm="5" cols="12" class="px-0 pt-1 pb-3">
                  <!-- eslint-disable-next-line -->
                  <v-autocomplete
                    dense
                    v-model="jobClassesFiltered"
                    chips
                    :items="jobClassesForCompaniesWithAll"
                    hide-details
                    label="MRC Job Classes"
                    deletable-chips
                    multiple
                    clearable
                    :loading="jcLoading"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </v-row>
          <v-row class="pb-4">
            <DetailsPlist
              :companiesSelected.sync="companiesSelectedForCompanies"
              :companyBenefits="companyBenefitsByCompanies"
              :loading="loading"
              :companyListHeight="companyListHeight - 50"
              :headerHeight.sync="headerHeight"
              :companyOnHover.sync="companyOnHover"
              @showIncumbents="showIncumbents"
              showRemove
              @removeSelected="removeSelected"
            >
            </DetailsPlist>
            <DetailsTabs
              :height="companyListHeight + headerHeight - 50"
              :loading="loading"
              :currencySelected="currencySelected"
              :companiesSelected="companiesSelectedForCompanies"
              :companyBenefits="companyBenefitsByCompanies"
              :sectors="sectorsForCompanies"
              :onetJobGroups="onetJobGroupsSelectedForCompanies"
              :countries="countriesForCompanies"
              :jobClasses="jobClassesFiltered"
              :companyOnHover="companyOnHover"
            >
            </DetailsTabs>
          </v-row>
        </v-tab-item>
        <v-tab-item class="mt-3 px-7">
          <v-row>
            <v-card elevation="2" class="px-6 pt-4 pb-2" style="width:100%;">
              <v-row justify="space-between" align="center">
                <v-col sm="5" cols="12" class="pt-2 pb-0">
                  <v-autocomplete
                    dense
                    label="Job Group"
                    hide-details
                    item-text="jobGroup"
                    item-value="jobGroup"
                    :items="onetJobGroupsForJobGroups"
                    v-model="onetJobGroupSelected"
                  ></v-autocomplete>
                </v-col>

                <v-col sm="5" cols="12" class="pt-2 pb-0">
                  <v-autocomplete
                    clearable
                    dense
                    :items="countriesWithHeader"
                    hide-details
                    label="Location"
                    @change="countriesForCompanyChanged"
                    item-text="countryName"
                    item-value="countryCode"
                    v-model="countryForJobGroup"
                  >
                    <template slot="item" slot-scope="data">
                      <v-list-item-content
                        v-if="data.item.header"
                        v-text="data.item"
                      ></v-list-item-content>
                      <v-divider v-else-if="data.item.divider" :inset="true"></v-divider>
                      <v-list-item-content v-else class="pb-2">
                        <v-list-item-title v-html="data.item.countryName"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.region"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="pt-2 pb-1">
                <v-divider></v-divider>
              </v-row>
              <v-row class="px-0" justify="space-between" align="center">
                <v-col sm="5" cols="12" class="pt-0 pb-4">
                  <v-select
                    hide-details
                    label="Compensation Component"
                    :disabled="!onetJobGroupSelected"
                    :items="compensationComponents"
                    v-model="compensationComponent"
                  >
                  </v-select>
                </v-col>
                <v-col sm="5" cols="12" class="pt-0 pb-4">
                  <v-radio-group
                    class="mt-0 pt-0"
                    v-model="selection"
                    hide-details
                    :disabled="!onetJobGroupSelected"
                  >
                    <v-radio value="earnings">
                      <template v-slot:label>
                        <v-text-field
                          label="Greater than"
                          :error-messages="invalidRange"
                          :rules="rules"
                          type="number"
                          class="pr-2"
                          v-model="greaterThan"
                        ></v-text-field>
                        <v-text-field
                          label="Lesser than"
                          :error-messages="invalidRange"
                          :rules="rules"
                          type="number"
                          class="pl-2"
                          v-model="lesserThan"
                        ></v-text-field>
                      </template>
                    </v-radio>
                    <v-radio value="topPaid">
                      <template v-slot:label>
                        <v-select
                          label="Top Paid Executives"
                          :items="topNs"
                          v-model="topN"
                          hide-details
                        ></v-select>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
          </v-row>
          <v-row class="pb-4">
            <DetailsPlist
              :companiesSelected.sync="companiesSelectedForJobGroup"
              :companyBenefits="companyBenefitsByJobGroup"
              :loading="loading"
              :companyListHeight="companyListHeight - 50"
              :headerHeight.sync="headerHeight"
              :companyOnHover.sync="companyOnHover"
              @showIncumbents="showIncumbents"
              showRemove
              @removeSelected="removeSelected"
            >
            </DetailsPlist>
            <DetailsTabs
              :height="companyListHeight + headerHeight - 50"
              :loading="loading"
              :currencySelected="currencySelected"
              :companiesSelected="companiesSelectedForJobGroup"
              :companyBenefits="companyBenefitsByJobGroup"
              :sectors="[]"
              :onetJobGroups="[onetJobGroupSelected]"
              :countries="[countryForJobGroup]"
              :jobClasses="[]"
              :compensationComponent="compensationComponent"
              :companyOnHover="companyOnHover"
            >
            </DetailsTabs>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-row>
    <v-menu
      :close-on-content-click="false"
      v-model="incMenuVisible"
      :position-x="incMenuX"
      :position-y="incMenuY"
      absolute
      offset-y
    >
      <v-list>
        <v-list-item
          @click="1 + 1"
          v-for="(p, i) in companyForSelection.positions"
          :key="p.name + p.title"
        >
          <v-checkbox
            :label="titleCase(p.name) + ' (' + p.title + ')'"
            :input-value="p.selected"
            @change="positionSelectedChanged(i, $event)"
          ></v-checkbox>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-container>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import DetailsPlist from '../components/DetailsPlist.vue';
import DetailsTabs from '../components/DetailsTabs.vue';
import debounce from '../debounce';

function companyInCompanyBenefits(company, companyBenefits) {
  for (let i = 0; i < companyBenefits.length; i += 1) {
    if (companyBenefits[i].company === company) {
      return true;
    }
  }
  return false;
}

const uniqBy = (arr, predicate) => {
  const cb = (o) => o[predicate];

  return [
    ...arr
      .reduce((map, item) => {
        const key = cb(item);
        // eslint-disable-next-line no-unused-expressions
        map.has(key) || map.set(key, item);
        return map;
      }, new Map())
      .values(),
  ];
};

export default Vue.extend({
  methods: {
    addCompanySelected(company) {
      const compIndex = this.companiesSelectedToAdd.findIndex((c) => c === company);
      if (compIndex < 0) {
        this.companiesSelectedToAdd.push(company);
      } else {
        this.companiesSelectedToAdd.splice(compIndex, 1);
      }
    },
    positionSelectedChanged(index, checked) {
      this.companyForSelection.positions[index].selected = checked;
      if (!checked) {
        this.companyForSelection.allPositionsSelected = false;
        return;
      }
      const pos = this.companyForSelection.positions.find((p) => !p.selected);
      if (!pos) {
        this.companyForSelection.allPositionsSelected = true;
      }
    },
    countriesForCompanyChanged(countryCode) {
      const currency = this.currencies.find((c) => c.countryCode === countryCode);
      if (currency) {
        this.setCurrencySelected(currency);
      }
    },
    countriesForSectorChanged(countryCodes) {
      if (countryCodes.length === 1) {
        const currency = this.currencies.find((c) => c.countryCode === countryCodes[0]);
        if (currency) {
          this.setCurrencySelected(currency);
        }
      }
    },
    onResize() {
      const heightLeft = window.innerHeight - 365;
      this.companyListHeight = heightLeft < 250 ? 250 : heightLeft;
    },
    searchCompanyName() {
      if (this.isFilterOn) {
        return;
      }
      if (!this.companySearchInput || this.companySearchInput.trim().length < 3) {
        return;
      }
      this.searchingCompanyByName = true;
      this.queryPublicCompaniesByName(this.companySearchInput)
        .then((data) => {
          if (data) {
            if (data.length === 0) {
              this.noCompanyMatch = true;
              setTimeout(() => {
                this.noCompanyMatch = false;
              }, 4000);
            }
            // eslint-disable-next-line max-len
            this.companiesForSearch = data.sort((a, b) => (a.company > b.company ? 1 : -1));
            this.companiesSelectedToAdd = this.companiesSelectedToAdd.filter(
              (c) => this.companiesForSearch.findIndex((x) => x.ticker === c.ticker) >= 0,
            );
          }
        })
        .finally(() => {
          this.searchingCompanyByName = false;
        });
    },
    addCompaniesByCompany() {
      const h = this.companyBenefitsByCompanies.concat(
        this.companiesSelectedToAdd.map((c) => ({
          ...c,
          positions: [],
        })),
      );
      const cbByCompanies = uniqBy(h, 'ticker');
      cbByCompanies.sort((a, b) => (a.company > b.company ? 1 : -1));
      this.companyBenefitsByCompanies = cbByCompanies.map((c) => ({
        ...c,
        allPositionsSelected: true,
      }));
      switch (this.filterTab) {
        case 0:
          this.companiesSelectedForSector = this.companiesSelectedForSector.concat(
            this.companiesSelectedToAdd.map((cb) => cb.company),
          );
          break;
        case 1:
          this.companiesSelectedForCompanies = this.companiesSelectedForCompanies.concat(
            this.companiesSelectedToAdd.map((cb) => cb.company),
          );
          break;
        default:
      }
      if (!this.isFilterOn) {
        this.companiesForSearch = [];
        this.companiesSelectedToAdd = [];
      }
    },
    removeSelected() {
      this.companyBenefitsByCompanies = this.companyBenefitsByCompanies.filter(
        (c) => !this.companiesSelectedForCompanies.includes(c.company),
      );
      this.companiesSelectedForCompanies = [];
    },
    toggle() {
      // this.$nextTick(() => {
      if (this.allSelected) {
        this.companiesSelectedToAdd = [];
      } else {
        this.companiesSelectedToAdd = this.companiesForSearchFiltered.slice();
      }
      // });
    },
    setMarketCapFrom(v) {
      if (!v) {
        this.marketCapFrom = null;
      } else {
        this.marketCapFrom = (+v / this.currencySelected.usdDivisor) * 1000000;
      }
    },
    setMarketCapTo(v) {
      if (!v) {
        this.marketCapTo = null;
      } else {
        this.marketCapTo = (+v / this.currencySelected.usdDivisor) * 1000000;
      }
    },
    setRevenueFrom(v) {
      if (!v) {
        this.revenueFrom = null;
      } else {
        this.revenueFrom = (+v / this.currencySelected.usdDivisor) * 1000000;
      }
    },
    setRevenueTo(v) {
      if (!v) {
        this.revenueTo = null;
      } else {
        this.revenueTo = (+v / this.currencySelected.usdDivisor) * 1000000;
      }
    },
    titleCase(str) {
      if (typeof str !== 'string') {
        return '';
      }
      const temp = str.toLowerCase().split(' ');
      for (let i = 0; i < temp.length; i += 1) {
        temp[i] = temp[i].charAt(0).toUpperCase() + temp[i].slice(1);
      }
      return temp.join(' ');
    },
    showIncumbents({ x, y, company }) {
      this.incMenuVisible = false;
      setTimeout(() => {
        this.incMenuX = x;
        this.incMenuY = y;
        this.companyForSelection = company;
        this.incMenuVisible = true;
      }, 5);
    },
    getCountryName(countryCode) {
      if (this.countries.length === 0) return '';
      const co = this.countries.find((c) => c.countryCode === countryCode);
      if (!co) return '';
      return co.countryName;
    },
    filterCurrency(item, queryText, itemText) {
      if (!queryText) {
        return false;
      }
      if (!item.currencyCode) {
        return false;
      }
      if (itemText.toLowerCase().startsWith(queryText.toLowerCase())) {
        return true;
      }
      if (item.countryName.toLowerCase().startsWith(queryText.toLowerCase())) {
        return true;
      }
      return false;
    },
    ...mapActions([
      'queryOnetJobGroups',
      'queryJobClasses',
      'queryCompanyBenefits',
      'queryPublicCompanies',
      'queryJobClassesInCompanies',
      'queryCompanyBenefitsForCompanies',
      'queryPublicCompaniesByName',
      'queryCompanyBenefitsByCompensation',
      'queryCompanyBenefitsByTopN',
      'queryOnetJobGroupsByCompanies',
    ]),
    ...mapMutations(['setOnetJobGroups', 'setCurrencySelected']),
  },
  watch: {
    companyBenefitsByJobGroup() {
      this.companiesSelectedForJobGroup = this.companyBenefitsByJobGroup.map((c) => c.company);
    },
    companiesSelectedForCompanies() {
      if (this.companiesSelectedForCompanies.length > 0) {
        this.queryOnetJobGroupsByCompanies(this.companiesSelectedForCompanies).then((data) => {
          if (data) {
            this.onetJobGroupsForCompanies = data;
          }
        });
      }
    },
    // sectorsSelected() {
    //   if (this.sectorsSelected.length > 0) {
    //     this.queryOnetJobGroups({ sectors: this.sectorsSelected, countryCodes: [] })
    //       .then((data) => {
    //         if (data.onetJobGroups) {
    //           this.setOnetJobGroups(data.onetJobGroups.map(o => ({ jobGroup: o })));
    //         }
    //       });
    //   } else {
    //     this.setOnetJobGroups([]);
    //   }
    // },
    revenueRangeSelected(val) {
      if (val === null) {
        this.revenueFromDisplay = null;
        this.revenueToDisplay = null;
      } else {
        this.revenueCustom = true;
        this.revenueFromDisplay = val.from / 1000000;
        this.revenueToDisplay = val.to / 1000000;
      }
      this.setRevenueFrom(this.revenueFromDisplay);
      this.setRevenueTo(this.revenueToDisplay);
    },
    marketCapRangeSelected(val) {
      if (val === null) {
        this.marketCapFromDisplay = null;
        this.marketCapToDisplay = null;
      } else {
        this.marketCapCustom = true;
        this.marketCapFromDisplay = val.from / 1000000;
        this.marketCapToDisplay = val.to / 1000000;
      }
      this.setMarketCapFrom(this.marketCapFromDisplay);
      this.setMarketCapTo(this.marketCapToDisplay);
    },
  },
  mounted() {
    if (this.$route.query.sector !== undefined && this.$route.query.country !== undefined
    && this.$route.query.jobGroup !== undefined && this.$route.query.jobClass !== undefined) {
      this.jobClassesSelected = [];
      this.queryOnetJobGroups({
        sectors: this.sectorsSelected,
        countryCodes: this.countriesSelected,
      }).then((data) => {
        if (data) {
          this.setOnetJobGroups(data.map((o) => ({ jobGroup: o })));
          this.loading = true;
          const input = {
            sectorNames: this.sectorsSelected,
            onetJobGroups: this.onetJobGroupsSelected,
            countryCodes: this.countriesSelected,
          };
          this.queryJobClasses(input)
            .then((data2) => {
              if (data2) {
                this.jobClasses = data2;
                this.jobClassesSelected = [parseInt(this.$route.query.jobClass, 10)];
              } else {
                this.jobClasses = [];
              }
            })
            .catch(() => {
              this.jobClasses = [];
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
    this.queryOnetJobGroups({ sectors: [], countryCodes: [] }).then((data) => {
      if (data) {
        const jg = data.map((o) => ({ jobGroup: o }));
        jg.sort((a, b) => {
          if (a.jobGroup === 'All' && b.jobGroup !== 'All') {
            return -1;
          }
          if (a.jobGroup !== 'All' && b.jobGroup === 'All') {
            return 1;
          }
          if (a.jobGroup === 'Executive Director' && b.jobGroup !== 'Executive Director') {
            return -1;
          }
          if (a.jobGroup !== 'Executive Director' && b.jobGroup === 'Executive Director') {
            return 1;
          }
          if (a.jobGroup === 'Non-Executive Director' && b.jobGroup !== 'Executive Director') {
            return -1;
          }
          if (a.jobGroup !== 'Non-Executive Director' && b.jobGroup === 'Executive Director') {
            return 1;
          }
          if (
            a.jobGroup === 'Independent Non-Executive Director'
            && b.jobGroup !== 'Executive Director'
          ) {
            return -1;
          }
          if (
            a.jobGroup !== 'Independent Non-Executive Director'
            && b.jobGroup === 'Executive Director'
          ) {
            return 1;
          }
          return a.jobGroup > b.jobGroup ? 1 : -1;
        });
        this.onetJobGroupsForJobGroups = jg;
      }
    });
    this.$watch(
      () => `sectors ${this.sectorsSelected.join(',')} | countryCodes: ${this.countriesSelected.join(
        ',',
      )}`,
      () => {
        if (this.sectorsSelected.length > 0 && this.countriesSelected.length > 0) {
          this.queryOnetJobGroups({
            sectors: this.sectorsSelected,
            countryCodes: this.countriesSelected,
          }).then((data) => {
            if (data) {
              this.setOnetJobGroups(data.map((o) => ({ jobGroup: o })));
            }
          });
        } else {
          this.setOnetJobGroups([]);
        }
      },
    );
    this.$watch(
      () => `JobClassesInCompanies - companies: ${this.companyBenefitsByCompanies
        .map((c) => c.ticker)
        .join(',')}, jobGroups: ${this.onetJobGroupsSelectedForCompanies.join(',')}`,
      () => {
        if (
          this.companyBenefitsByCompanies.length > 0
          && this.onetJobGroupsSelectedForCompanies.length > 0
        ) {
          this.jcLoading = true;
          const input = {
            tickers: this.companyBenefitsByCompanies.map((c) => c.ticker),
            onetJobGroups: this.onetJobGroupsSelectedForCompanies,
          };
          this.queryJobClassesInCompanies(input)
            .then((data) => {
              if (data) {
                this.jobClassesForCompanies = data;
              }
            })
            .finally(() => {
              this.jcLoading = false;
            });
        } else {
          this.jobClassesForCompanies = [];
        }
      },
    );
    this.$watch(
      () => `CompanyBenefitsForCompanies - companies: ${this.companyBenefitsByCompanies
        .map((c) => c.ticker)
        .join(',')}, jobGroups: ${this.onetJobGroupsSelectedForCompanies.join(
        ',',
      )}, jobClasses: ${this.jobClassesFiltered}`,
      () => {
        if (
          this.companyBenefitsByCompanies.length > 0
          && this.onetJobGroupsSelectedForCompanies.length > 0
          && this.jobClassesFiltered.length > 0
        ) {
          const input = {
            tickers: this.companyBenefitsByCompanies.map((c) => c.ticker),
            onetJobGroups: this.onetJobGroupsSelectedForCompanies,
            jobClasses: this.jobClassesFiltered.map((jc) => (jc === 'All' ? -1 : jc)),
          };
          this.loading = true;
          this.queryCompanyBenefitsForCompanies(input)
            .then((data) => {
              if (data) {
                this.companyBenefitsByCompanies = this.companyBenefitsByCompanies.map((c) => {
                  const cb = data.find((x) => x.ticker === c.ticker);
                  if (!cb) {
                    return {
                      ...c,
                      allPositionsSelected: true,
                      positions: [],
                    };
                  }
                  return { ...cb, allPositionsSelected: true };
                });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.companyBenefitsByCompanies = this.companyBenefitsByCompanies.map((cb) => ({
            ...cb,
            allPositionsSelected: true,
            positions: [],
          }));
        }
      },
    );
    this.$watch(
      () => `JobClasses - sector: ${this.sectorsSelected.join(
        ',',
      )} - jobgroup: ${this.onetJobGroupsSelected.join(
        ',',
      )} - countryCode: ${this.countriesSelected.join(',')}`,
      () => {
        const input = {
          sectorNames: this.sectorsSelected,
          onetJobGroups: this.onetJobGroupsSelected,
          countryCodes: this.countriesSelected,
        };
        this.loading = true;
        this.queryJobClasses(input)
          .then((data) => {
            if (data) {
              this.jobClasses = data;
            } else {
              this.jobClasses = [];
            }
          })
          .catch(() => {
            this.jobClasses = [];
          })
          .finally(() => {
            this.loading = false;
          });
      },
    );
    this.$watch(
      () => `CompanyBenefits - sector: ${this.sectorsSelected.join(
        ',',
      )} - jobgroup: ${this.onetJobGroupsSelected.join(
        ',',
      )} - countryCode: ${this.countriesSelected.join(
        ',',
      )} - jobClasses: ${this.jobClassesSelected.join(',')}`,
      () => {
        const input = {
          sectorNames: this.sectorsSelected,
          onetJobGroups: this.onetJobGroupsSelected,
          countryCodes: this.countriesSelected,
          jobClasses: this.jobClassesSelected.map((n) => {
            if (n === 'All') {
              return -1;
            }
            return n;
          }),
        };
        this.loading = true;

        // fetch('/exec-comp/api/companyBenefits', {
        //   method: 'POST',
        //   headers: {
        //     Accept: 'application/json',
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify(input),
        // })
        // .then((resp) => {
        //   if (resp.ok && resp.status === 200) {
        //     return resp.json();
        //   }
        //   throw resp.statusText;
        // })
        // .then((d) => ({ companyBenefits: d }))
        this.queryCompanyBenefits(input)
          .then((data) => {
            if (
              this.companiesToBeSelected.length === 0
              && this.companiesSelected.length === this.companyBenefits.length
            ) {
              switch (this.filterTab) {
                case 0:
                  this.companiesSelectedForSector = data.map((c) => c.company);
                  break;
                case 1:
                  this.companiesSelectedForCompanies = data.map((c) => c.company);
                  break;
                default:
                  break;
              }
            } else {
              switch (this.filterTab) {
                case 0:
                  this.companiesSelectedForSector = [
                    ...this.companiesSelectedForSector,
                    ...this.companiesToBeSelected,
                  ];
                  this.companiesSelectedForSector = [
                    ...new Set(this.companiesSelectedForSector),
                  ].filter((c) => companyInCompanyBenefits(c, data));
                  break;
                case 1:
                  this.companiesSelectedForCompanies = [
                    ...this.companiesSelectedForCompanies,
                    ...this.companiesToBeSelected,
                  ];
                  this.companiesSelectedForCompanies = [
                    ...new Set(this.companiesSelectedForCompanies),
                  ].filter((c) => companyInCompanyBenefits(c, data));
                  break;
                default:
                  break;
              }
              this.companiesToBeSelected = [];
            }
            const cbBySector = data;
            cbBySector.sort((a, b) => (a.company.toLowerCase() > b.company.toLowerCase() ? 1 : -1));

            this.companyBenefitsBySector = cbBySector.map((c) => ({
              ...c,
              allPositionsSelected: true,
            }));
          })
          .catch(() => {
            // eslint-disable-next-line
            console.error('error');
          })
          .finally(() => {
            this.loading = false;
          });
      },
    );
    this.$watch(
      () => `Public Companies - sector: ${this.sectorForCompanies} - country: ${this.countryForCompanies} - revenueFrom: ${this.revenueFrom} - revenueTo: ${this.revenueTo} - marketCapFrom: ${this.marketCapFrom} - marketCapTo: ${this.marketCapTo} - hkFilter: ${this.hkFilter} - sgFilter: ${this.sgFilter}`,
      () => {
        let { hkFilter } = this;
        if (this.countryForCompanies !== 'HKG') {
          hkFilter = null;
        }
        let { sgFilter } = this;
        if (this.countryForCompanies !== 'SGP') {
          sgFilter = null;
        }
        if (!this.isFilterOn) {
          this.companiesForSearch = [];
          this.companiesSelectedToAdd = [];
          return;
        }
        let isRevenueInvalid = false;
        let isMktCapInvalid = false;
        if (this.revenueFrom && this.revenueTo) {
          if (this.revenueTo <= this.revenueFrom) {
            this.invalidRevenueRange = 'Invalid range';
            isRevenueInvalid = true;
          }
        }
        if (!isRevenueInvalid) {
          this.invalidRevenueRange = '';
        }
        if (this.marketCapFrom && this.marketCapTo) {
          if (this.marketCapTo <= this.marketCapFrom) {
            this.invalidMktCapRange = 'Invalid range';
            isMktCapInvalid = true;
          }
        }
        if (!isMktCapInvalid) {
          this.invalidMktCapRange = '';
        }
        if (isRevenueInvalid || isMktCapInvalid) {
          return;
        }
        this.publicCompaniesLoading = true;
        this.queryPublicCompanies({
          sector: this.sectorForCompanies || null,
          country: this.countryForCompanies || null,
          revenueFrom: this.revenueFrom,
          revenueTo: this.revenueTo,
          marketCapFrom: this.marketCapFrom,
          marketCapTo: this.marketCapTo,
          hkFilter,
          sgFilter,
        })
          .then((data) => {
            if (data) {
              // eslint-disable-next-line max-len
              this.companiesForSearch = data.sort((a, b) => (a.company > b.company ? 1 : -1));
            } else {
              this.companiesForSearch = [];
            }
            this.companiesSelectedToAdd = this.companiesSelectedToAdd.filter(
              (c) => this.companiesForSearch.findIndex((x) => x.ticker === c.ticker) >= 0,
            );
          })
          .finally(() => {
            if (this.countryForCompanies !== 'HKG') {
              this.hkFilter = null;
            }
            if (this.countryForCompanies !== 'SGP') {
              this.sgFilter = null;
            }
            this.publicCompaniesLoading = false;
          });
      },
    );
    this.$watch(
      () => `Job Group - jobgroup: ${this.onetJobGroupSelected} - country: ${this.countryForJobGroup} - compensationComponent: ${this.compensationComponent} - selection: ${this.selection} - greaterThan: ${this.greaterThan} - lesserThan: ${this.lesserThan} - topN: ${this.topN} - currency: ${this.currencySelected.usdDivisor}`,
      debounce(() => {
        if (!this.onetJobGroupSelected) return;
        if (!this.selection) return;
        const q = {
          jobGroup: this.onetJobGroupSelected,
        };
        if (this.countryForJobGroup) {
          q.countryCode = this.countryForJobGroup;
        }
        switch (this.selection) {
          case 'earnings':
            if (this.greaterThan === '' && this.lesserThan === '') return;
            if (this.greaterThan !== '' && this.lesserThan !== '') {
              if (+this.lesserThan <= +this.greaterThan) {
                this.invalidRange = 'Invalid range';
                return;
              }
            }
            this.invalidRange = '';
            q.compensationComponent = this.compensationComponent;
            if (this.greaterThan !== '') {
              q.greaterThan = +this.greaterThan / this.currencySelected.usdDivisor;
            }
            if (this.lesserThan !== '') {
              q.lesserThan = +this.lesserThan / this.currencySelected.usdDivisor;
            }
            // make query
            this.loading = true;
            this.queryCompanyBenefitsByCompensation(q)
              .then((data) => {
                let cbByComp = data;
                cbByComp.sort((a, b) => (a.company > b.company ? 1 : -1));
                cbByComp = cbByComp.map((c) => ({ ...c, allPositionsSelected: true }));
                this.companyBenefitsByJobGroup = cbByComp;
              })
              .finally(() => {
                this.loading = false;
              });
            break;
          case 'topPaid':
            if (!this.topN) return;
            q.compensationComponent = this.compensationComponent;
            q.n = this.topN;
            // make query
            this.loading = true;
            this.queryCompanyBenefitsByTopN(q)
              .then((data) => {
                let cbByComp = data;
                cbByComp.sort((a, b) => (a.company > b.company ? 1 : -1));
                cbByComp = cbByComp.map((c) => ({ ...c, allPositionsSelected: true }));
                this.companyBenefitsByJobGroup = cbByComp;
              })
              .finally(() => {
                this.loading = false;
              });
            break;
          default:
            break;
        }
      }, 1500),
    );
  },
  computed: {
    companiesSelectedToAddInFiltered() {
      return this.companiesSelectedToAdd.filter((c) => this.companiesForSearchFiltered.includes(c));
    },
    virtualScrollHeight() {
      if (this.companiesForSearchFiltered.length > 5) {
        return 294;
      }
      return this.companiesForSearchFiltered.length * 56;
    },
    companiesForSearchFiltered() {
      if (this.companySearchInput.trim() !== '') {
        return this.companiesForSearch.filter((c) => c.company.toLowerCase()
          .includes(this.companySearchInput.toLowerCase()));
      }
      return this.companiesForSearch;
    },
    countriesForCompanies() {
      const countryMap = {};
      this.companyBenefitsByCompanies
        .filter((c) => this.companiesSelectedForCompanies.includes(c.company))
        .forEach((c) => {
          countryMap[c.country] = true;
        });
      return Object.keys(countryMap)
        .map((code) => {
          const x = this.countries.find((c) => c.countryCode === code);
          if (x) return x.countryName;
          return '';
        })
        .filter((x) => x !== '');
    },
    sectorsForCompanies() {
      const sectorMap = {};
      this.companyBenefitsByCompanies
        .filter((c) => this.companiesSelectedForCompanies.includes(c.company))
        .forEach((c) => {
          sectorMap[c.sector] = true;
        });
      return Object.keys(sectorMap);
    },
    isFilterOn() {
      if (
        (!this.sectorForCompanies || this.sectorForCompanies === 'All')
        && !this.countryForCompanies
        && !this.revenueFrom
        && !this.revenueTo
        && !this.marketCapFrom
        && !this.marketCapTo
      ) {
        return false;
      }
      return true;
    },
    companyBenefits() {
      switch (this.filterTab) {
        case 0:
          return this.companyBenefitsBySector;
        case 1:
          return this.companyBenefitsByCompanies;
        default:
          return [];
      }
    },
    companiesSelected() {
      switch (this.filterTab) {
        case 0:
          return this.companiesSelectedForSector;
        case 1:
          return this.companiesSelectedForCompanies;
        default:
          return [];
      }
    },
    textForCompanySearch() {
      if (this.isFilterOn) {
        return 'No company found...';
      }
      if (this.searchingCompanyByName) {
        return 'Searching...';
      }
      if (this.noCompanyMatch) {
        return 'No matching company found...';
      }
      if (!this.companySearchInput || this.companySearchInput.trim().length === 0) {
        return 'Enter a company name...';
      }
      if (this.companySearchInput.trim().length < 3) {
        return 'Enter at least 3 characters...';
      }
      if (this.companySearchInput.trim().length >= 3) {
        return "Press 'Enter' to search...";
      }
      return 'No company found...';
    },
    allSelected() {
      return this.companiesSelectedToAdd.length === this.companiesForSearch.length;
    },
    someSelected() {
      return this.companiesSelectedToAdd.length > 0 && !this.allSelected;
    },
    icon() {
      if (this.allSelected) return 'check_box';
      if (this.someSelected) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
    jobClassesWithAll() {
      if (this.jobClasses && this.jobClasses.length === 0) return [];
      return ['All', ...this.jobClasses];
    },
    jobClassesForCompaniesWithAll() {
      if (this.jobClassesForCompanies && this.jobClassesForCompanies.length === 0) return [];
      return ['All', ...this.jobClassesForCompanies];
    },
    currenciesGrouped() {
      const currencyWithGroup = [];
      if (this.currencies.length === 0) return currencyWithGroup;
      currencyWithGroup.push({ header: this.currencies[0].continent });
      this.currencies.forEach((c, i) => {
        if (c.currencyCode === 'USD' && c.countryName !== 'United States') {
          return;
        }
        if (i !== 0 && c.continent !== this.currencies[i - 1].continent) {
          currencyWithGroup.push({ divider: true });
          currencyWithGroup.push({ header: c.continent });
        }
        currencyWithGroup.push({
          countryName: c.countryName,
          currencyCode: c.currencyCode,
          region: c.region,
          continent: c.continent,
          usdDivisor: c.usdDivisor,
          __typename: c.__typename, // eslint-disable-line
        });
      });
      return currencyWithGroup;
    },
    overviewRoute() {
      const query = {};
      if (this.sectorsSelected.length > 0) {
        [query.sector] = this.sectorsSelected;
      }
      if (this.onetJobGroupsSelected.length > 0) {
        [query.jobGroup] = this.onetJobGroupsSelected;
      }
      return {
        path: '/public/ladder',
        query,
      };
    },
    items() {
      return [
        {
          text: 'Home',
          disabled: true,
        },
        {
          text: 'Ladder',
          disabled: false,
          to: this.overviewRoute,
        },
      ];
    },
    countriesWithHeader() {
      const countriesWithHeader = [];
      if (this.countries.length === 0) {
        return countriesWithHeader;
      }
      countriesWithHeader.push({ header: this.countries[0].continent });
      this.countries.forEach((c, i) => {
        if (i !== 0 && c.continent !== this.countries[i - 1].continent) {
          countriesWithHeader.push({ header: c.continent });
        }
        countriesWithHeader.push({
          countryName: c.countryName,
          countryCode: c.countryCode,
          region: c.region,
          continent: c.continent,
          __typename: c.__typename, // eslint-disable-line
        });
        if (i !== this.countries.length - 1 && c.continent !== this.countries[i + 1].continent) {
          countriesWithHeader.push({ divider: 1 });
        }
      });
      return countriesWithHeader;
    },
    ...mapState({
      currencySelected: (state) => state.currencySelected,
      allSectors: (state) => state.sectors,
      countries: (state) => state.countries,
      currencies: (state) => state.currencies,
      onetJobGroups: (state) => state.onetJobGroups,
    }),
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.country) {
      this.countriesSelected = [to.query.country];
    }
    if (to.query.jobClass) {
      this.jobClassesSelected = [+to.query.jobClass];
    }
    if (to.query.jobGroup) {
      this.onetJobGroupsSelected = [to.query.jobGroup];
    }
    if (to.query.sector) {
      this.sectorsSelected = [to.query.sector];
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.country) {
        // eslint-disable-next-line
        vm.countriesSelected = [to.query.country];
      }
      if (to.query.jobClass) {
        // eslint-disable-next-line
        vm.jobClassesSelected = [+to.query.jobClass];
      }
      if (to.query.jobGroup) {
        // eslint-disable-next-line
        vm.onetJobGroupsSelected = [to.query.jobGroup];
      }
      if (to.query.sector) {
        // eslint-disable-next-line
        vm.sectorsSelected = [to.query.sector];
      }
    });
  },
  data() {
    return {
      companiesSelectedForJobGroup: [],
      hkFilters: [
        { value: 'isHShares', text: 'H Shares (CN stocks inc. in CN, listed in HK)' },
        { value: 'isHSIConstituents', text: 'HSI Constituents' },
        { value: 'isRedChips', text: 'Red Chips (CN stocks inc. outside CN, listed in HK)' },
        { value: 'nonHShareRedChips', text: 'Non H Share and Red Chips' },
      ],
      hkFilter: '',
      sgFilters: [{ value: 'isSTIConstituents', text: 'STI Constituents' }],
      sgFilter: '',
      rules: [(value) => !value || value > 0 || 'Must be greater than 0'],
      invalidRevenueRange: '',
      invalidMktCapRange: '',
      invalidRange: '',
      selection: '',
      greaterThan: '',
      lesserThan: '',
      publicCompaniesLoading: false,
      jcLoading: false,
      noCompanyMatch: false,
      searchingCompanyByName: false,
      onetJobGroupsForCompanies: [],
      onetJobGroupsForJobGroups: [],
      allOnetJobGroups: [],
      filterTab: 0,
      sectorForCompanies: '',
      countryForCompanies: '',
      countryForJobGroup: '',
      onetJobGroupsSelectedForCompanies: [],
      jobClassesForCompanies: [],
      jobClassesFiltered: [],
      companySearchInput: '',
      companiesForSearch: [],
      companiesSelectedToAdd: [],
      companyBenefitsByCompanies: [],
      companyOnHover: '',
      companyForSelection: {},
      incMenuX: 0,
      incMenuY: 0,
      incMenuVisible: false,
      loading: false,
      companySearchText: '',
      companiesToBeSelected: [],
      addCompanyDialogVisible: false,
      headerHeight: 108,
      companiesSelectedForSector: [],
      companiesSelectedForCompanies: [],
      companyBenefitsBySector: [],
      companyBenefitsByJobGroup: [],
      jobClasses: [],
      jobClassesSelected: [],
      countriesSelected: [],
      sectorsSelected: [],
      onetJobGroupsSelected: [],
      onetJobGroupSelected: '',
      companyListHeight: 500,
      topNs: [
        {
          text: 'Top 5',
          value: 5,
        },
        {
          text: 'Top 10',
          value: 10,
        },
        {
          text: 'Top 20',
          value: 20,
        },
        {
          text: 'Top 50',
          value: 50,
        },
      ],
      topN: '',
      compensationComponent: 'totalCashUSD',
      compensationComponents: [
        {
          text: 'C1: Basic Salary (p.a.)',
          value: 'salaryUSD',
        },
        {
          text: 'C2: Fixed Cash (p.a.)',
          value: 'fixedCashUSD',
        },
        {
          text: 'C3: Total Cash (p.a.)',
          value: 'totalCashUSD',
        },
        {
          text: 'C4: Total Direct Compensation (p.a.)',
          value: 'totalDirectCompensationUSD',
        },
        {
          text: 'C5: Total Remuneration (p.a.)',
          value: 'totalRemunerationUSD',
        },
        {
          text: 'C6: Total Cost to Company (p.a.)',
          value: 'totalCostUSD',
        },
      ],
      marketCaps: [
        {
          text: '< 30M',
          value: {
            from: 0,
            to: 30000000,
          },
        },
        {
          text: '30M - 150M',
          value: {
            from: 30000000,
            to: 150000000,
          },
        },
        {
          text: '150M - 500M',
          value: {
            from: 150000000,
            to: 500000000,
          },
        },
        {
          text: '500M - 1B',
          value: {
            from: 500000000,
            to: 1000000000,
          },
        },
        {
          text: '1B - 4B',
          value: {
            from: 1000000000,
            to: 4000000000,
          },
        },
        {
          text: '> 4B',
          value: {
            from: 4000000000,
          },
        },
      ],
      revenues: [
        {
          text: '< 50M',
          value: {
            from: 0,
            to: 50000000,
          },
        },
        {
          text: '50M - 200M',
          value: {
            from: 50000000,
            to: 200000000,
          },
        },
        {
          text: '200M - 1B',
          value: {
            from: 200000000,
            to: 1000000000,
          },
        },
        {
          text: '1B - 5B',
          value: {
            from: 1000000000,
            to: 5000000000,
          },
        },
        {
          text: '5B - 20B',
          value: {
            from: 5000000000,
            to: 20000000000,
          },
        },
        {
          text: '> 20B',
          value: {
            from: 20000000000,
          },
        },
      ],
      revenueRangeSelected: null,
      revenueFromDisplay: null,
      revenueCustom: false,
      revenueFrom: null,
      revenueToDisplay: null,
      revenueTo: null,
      marketCapRangeSelected: null,
      marketCapFromDisplay: null,
      marketCapCustom: false,
      marketCapFrom: null,
      marketCapToDisplay: null,
      marketCapTo: null,
    };
  },
  components: {
    DetailsTabs,
    DetailsPlist,
  },
});
</script>
<style scoped>
.singleline {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
